'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _domUtil = require('../../utils/domUtil');

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

var _ModalKeyboardManager = require('./ModalKeyboardManager');

var _ModalKeyboardManager2 = _interopRequireDefault(_ModalKeyboardManager);

require('./FullScreenModal.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Utils
var FullScreenModal = function FullScreenModal(props) {
    var children = props.children,
        className = props.className,
        overlay = props.overlay,
        close = props.close,
        backButtonRoutes = props.backButtonRoutes;


    return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)('FullScreenModal', className, { overlay: overlay }), onClick: close },
        _react2.default.createElement(
            'div',
            { className: 'modal-positioner' },
            _react2.default.createElement(
                _ModalKeyboardManager2.default,
                props,
                _react2.default.createElement(
                    _Modal2.default,
                    { onClick: _domUtil.stopPropagationOnly, close: close, backButtonRoutes: backButtonRoutes },
                    children
                )
            )
        )
    );
};

// Styles


// Components
// Lib


FullScreenModal.propTypes = {
    children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.array]).isRequired,
    className: _propTypes2.default.string,
    overlay: _propTypes2.default.bool,
    close: _propTypes2.default.func,
    backButtonRoutes: _propTypes2.default.array
};

exports.default = FullScreenModal;


//////////////////
// WEBPACK FOOTER
// ./src/client/components/modal/FullScreenModal.js
// module id = 125
// module chunks = 0